import React from "react";
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType } from 'docx';import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { constants } from "../constants";

const ExportDocument = ({ selectedItem, setSelectedItem, data }) => {
  const exportData = () => {
    switch (selectedItem) {
      case "DOC":
        generateDoc();
        break;
      case "PDF":
        generatePDF();
        break;
      case "XLSX":
        generateXLSX();
        break;
      default:
        alert("Please select an export format.");
    }
  };

  const generateDoc = () => {
    const tableRows = [
      new TableRow({
      key: "header-row",
      children: [
        new TableCell({ children: [new Paragraph("File Name")], width: { size: 20, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("Upload  Date")], width: { size: 20, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("File Size(MB)")], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("File Type")], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("# of Columns")], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("# of Rows")], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("Status")], width: { size: 10, type: WidthType.PERCENTAGE } }),
        new TableCell({ children: [new Paragraph("Failure Reasons")], width: { size: 10, type: WidthType.PERCENTAGE } }),
      ],
      }),
      ...data.map((item, index) =>
      new TableRow({
        key: item.id ?? `${item.file_name}-${item.processed_at}-${index}`,
        children: [
        new TableCell({ children: [new Paragraph(item.file_name)] }),
        new TableCell({ children: [new Paragraph(item.processed_at)] }),
        new TableCell({ children: [new Paragraph(item.file_size ? item.file_size : "")] }),
        new TableCell({ children: [new Paragraph(item.file_type ? item.file_type : "")] }),
        new TableCell({ children: [new Paragraph(item.no_of_columns ? item.no_of_columns.toString() : "")] }),
        new TableCell({ children: [new Paragraph(item.no_of_rows ? item.no_of_rows.toString() : "")] }),
        new TableCell({ children: [new Paragraph(item.status)] }),
        new TableCell({ children: [new Paragraph(item.failure_reasons ? item.failure_reasons : "")] }),
        ],
      })
      ),
    ];

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "Documents Data",
                  bold: true,
                  size: 24,
                }),
              ],
              spacing: {
                after: 200,
              },
            }),
            new Table({
              rows: tableRows,
              width: {
                size: 100,
                type: WidthType.PERCENTAGE,
              },
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, `export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.docx`);
    });
  };

  const generatePDF = async () => {
    const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
    const fileName = `export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.pdf`;

    pdf.setFontSize(14);
    pdf.text("Documents Data", 10, 10);

    pdf.autoTable({
      startY: 15,
      theme: "grid",
      head: [['File Name', 'Upload Date','File Size', 'File Type', 'No of Columns', 'No of Rows','Status','Failure Reasons']],
      body: data.map(item => [
        item.file_name || '',
        item.processed_at || '',
        item.file_size || '',
        item.file_type || '',
        item.no_of_columns ? item.no_of_columns.toString() : '',
        item.no_of_rows ? item.no_of_rows.toString() : '',
        item.status || '',
        item.failure_reasons || ''
      ]),
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak',
        valign: 'middle',
      },
      headStyles: {
        fillColor: [242, 245, 250],
        textColor: [11, 28, 51],
        fontStyle: 'bold',
      },
      margin: { top: 15, right: 10, bottom: 10, left: 10 },
      tableWidth: 'wrap',
      columnStyles: {
        0: { cellWidth: 58 },
        1: { cellWidth: 32 },
        2: { cellWidth: 20, halign: 'center' },
        3: { cellWidth: 24 },
        4: { cellWidth: 24, halign: 'center' },
        5: { cellWidth: 20, halign: 'center' },
        6: { cellWidth: 22, halign: 'center' },
        7: { cellWidth: 77 },
      },
    });

    pdf.save(fileName);
  };

  const generateXLSX = () => {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: ['file_name', 'processed_at', 'file_size', 'file_type','no_of_columns','no_of_rows', 'status', 'failure_reasons'] });
    XLSX.utils.sheet_add_aoa(worksheet, [
      ['File Name',  'Upload Date', 'File Size(MB)','File Type', '# of Columns','# of Rows',   'Status','Failure Reasons']
    ], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`);
  };
  return (
    <>
      <Col xs="auto">
        <DropdownButton
          id="dropdown-basic-button"
          title={selectedItem}
          variant="outline-primary"
          className="btn-light dropdown-custom-color"
        >
          {constants.FILE_TYPE.map((item) => (
            <Dropdown.Item
              key={item}
              eventKey={item}
              onClick={() => setSelectedItem(item)}
            >
              {item}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </Col>
      <Col xs="auto">
        <Button
          onClick={exportData}
          className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color"
        >
          Export As
        </Button>
      </Col>      
    </>
  );
};

export default ExportDocument;
